var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9736 35.8467C27.723 35.8467 35.6264 27.9432 35.6264 18.1938C35.6264 8.44445 27.723 0.541016 17.9736 0.541016C8.22424 0.541016 0.320801 8.44445 0.320801 18.1938C0.320801 27.9432 8.22424 35.8467 17.9736 35.8467Z",
    fill: "#3B5998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4116 18.8849H19.2617V30.4247H14.4893V18.8849H12.2195V14.8293H14.4893V12.2049C14.4893 10.3281 15.3807 7.38934 19.3042 7.38934L22.8392 7.40413V11.3408H20.2743C19.8536 11.3408 19.262 11.551 19.262 12.4462V14.8331H22.8285L22.4116 18.8849Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.abb4e87a5f4507a16b36bea9a00d8745.svg";
export { ForwardRef as ReactComponent };